/*
 * Ryan O'Dowd
 * 2024-09-27
 * © Copyright 2024 Oakwood Software Consulting, Inc.  All Rights Reserved.
 */

const getStyles = ({globalScale, fonts, colors}) => {
  return {
    sectionWrapper: {
      flex: 1,
      width: '100%',
      flexDirection: 'column',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    nameAndLink: {
      display: 'flex',
      flexDirection: 'row',
      gap: 4,
      alignItems: 'center',
    },
    joinCode: {
      backgroundColor: colors.accent,
      color: colors.primaryExtraDark,
      fontWeight: '600',
      borderRadius: 8,
      paddingTop: 4,
      paddingRight: 4,
      paddingBottom: 4,
      paddingLeft: 8,
    },
    editButton: {
      margin: 0,
    },
    titleWrapper: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
    },
    schoolTitleText: {
      color: colors.primaryExtraLight,
      fontSize: globalScale * 16,
      fontFamily: fonts.secondaryBold,
    },
    teacherNameAndActions: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-end',
      alignItems: 'center',
      gap: 4,
    },
  };
};

export default getStyles;
